import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import { ToastContext } from "@weezevent/nacre";

import { formatDuplication } from "utils/checkpoints";
import { GET, POST } from "utils/fetcher";
import useRouterContext from "../../../../context/routerContext";

export default function useDuplicateCheckpoint() {
	const history = useHistory();
	const location = useLocation();
	const { t } = useTranslation();
	const { path } = useRouterContext();
	const { success } = React.useContext(ToastContext);

	return async ({ checkpoint }) => {
		const { data } = await GET(
			`/bo/organizers/${
				checkpoint.organizationId
			}/checkpoints/${checkpoint.id()}/`
		);

		const formatedCheckpoint = formatDuplication(data, {
			name: `${checkpoint.name()} ${t("access.common.copy")}`
		});

		// Delete of rules_v2 and supporting_document_rules (ids) before sending the post request

		delete formatedCheckpoint.rules_v2;

		formatedCheckpoint.supporting_document_rules = formatedCheckpoint.supporting_document_rules.map(
			rule => {
				const { id, supporting_document_definition, ...rest } = rule;
				delete supporting_document_definition.id;
				return {
					...rest,
					supporting_document_definition
				};
			}
		);

		const { data: newCheckpoint } = await POST(
			`/bo/organizers/${checkpoint.organizationId}/checkpoints/`,
			JSON.stringify(formatedCheckpoint)
		);

		success(
			t("access.checkpoint.duplicateSuccessTitle", {
				list: checkpoint.name()
			})
		);

		history.push(
			`${path}/checkpoints/edit/${newCheckpoint.id}${location.search}`
		);

		return newCheckpoint;
	};
}
